// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"eec79aaa","667":"f220abc3","884":"5f0f383a","977":"017beeb8"}[chunkId] + ".chunk.js";
};